import EventBus from '@zageno/event-bus';
import isEqual from 'lodash.isequal';
import { useEffect, useState } from 'react';

import { FeatureFlagEvents } from '../events';
import { FeatureFlags } from '../providers/FeatureFlag';

export function useFeatureFlag(): Partial<FeatureFlags> {
  const [featureFlags, setFeatureFlags] = useState<Partial<FeatureFlags>>({});

  useEffect(() => {
    const subscriptionId = EventBus.subscribe<FeatureFlags>(FeatureFlagEvents.CHANGE, ({ data }) => {
      setFeatureFlags(prevState => {
        if (!isEqual(prevState, data)) {
          return data;
        }

        return prevState;
      });
    });

    return () => EventBus.unsubscribe(subscriptionId);
  }, []);

  return featureFlags;
}
